import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Columns from "./components/Columns";
import Feed from "./components/Feed";
import Exclusive from "./components/Exclusive";
import Topics from "./components/Topics";
import TipForm from "./components/TipForm";
import FaqSection from "./components/FaqSection";
import About from "./components/About";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <main id="top" className="min-h-screen">
      {/* 页首品牌（单页唯一 H1） */}
      <h1 className="sr-only">呱呱爆料 · 独家猛料首发曝光，一手消息内部流出，绝密文件抢先看</h1>
      <Navbar />
      <Hero />
      <Columns />
      <Feed />
      <Exclusive />
      <Topics />
      <TipForm />
      <FaqSection />
      <About />
      <Footer />
    </main>
  );
}